import { Subject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

export class ModalRef<R = any> {
  private readonly _afterClosed = new Subject<R | undefined>();
  private readonly _output = new Subject<{ event: string; data: unknown }>();

  afterClosed(): Observable<R | undefined> {
    return this._afterClosed.asObservable().pipe(take(1));
  }

  output<T = unknown>(eventName: string): Observable<T> {
    return this._output.asObservable().pipe(
      filter(({ event }) => event === eventName),
      map(({ data }) => data as T)
    );
  }

  close(result?: R): void {
    this._afterClosed.next(result);
    this._afterClosed.complete();
    this._output.complete();
  }

  emit(event: string, data?: unknown): void {
    this._output.next({ event, data });
  }
}
